<main class="auth-pages">
    <div class="loader-outer">
        <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</main>